
import React from 'react';
import ReviewCard from '../ReviewCard';
import AIReplyCard from '../AIReplyCard';
import industryData, { IndustryType, SentimentType } from '@/data/industryData';

interface ConversationDisplayProps {
  industry: IndustryType;
  isPositive: boolean;
}

const ConversationDisplay: React.FC<ConversationDisplayProps> = ({ industry, isPositive }) => {
  const sentiment: SentimentType = isPositive ? 'positive' : 'negative';
  const currentReview = industryData[industry][sentiment];

  return (
    <div className="mt-2 grid grid-cols-1 gap-8">
      <div className="flex justify-start">
        <div className="flex items-start gap-4 max-w-[85%]">
          <div className="min-w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 font-semibold text-lg hidden sm:flex">
            {currentReview.name.charAt(0)}
          </div>
          <div className="flex-1">
            <ReviewCard
              name={currentReview.name}
              stars={currentReview.stars}
              date={currentReview.date}
              text={currentReview.text}
              style="classic"
              animation="animate-fade-in"
              isPositive={isPositive}
            />
          </div>
        </div>
      </div>
      
      <div className="flex justify-end">
        <div className="flex items-start gap-4 max-w-[85%]">
          <div className="flex-1">
            <AIReplyCard
              text={currentReview.reply}
              style="classic"
              animation="animate-fade-in"
              isPositive={isPositive}
            />
          </div>
          <div className="min-w-12 h-12 bg-blue-200 rounded-full flex items-center justify-center text-blue-500 font-semibold text-lg hidden sm:flex">
            IA
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversationDisplay;
